/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export const /** @type {?} */ NO_LAYOUT_CLASS = "datagrid-no-layout";
export const /** @type {?} */ COMPUTE_WIDTH_CLASS = "datagrid-computing-columns-width";
export const /** @type {?} */ STRICT_WIDTH_CLASS = "datagrid-fixed-width";
